import React, { useCallback, useEffect, useMemo } from "react";

import { useAppDispatch, useAppSelector } from "hooks/reduxHooks";
import Skeleton from "react-loading-skeleton";
import {
  selectCurrentExam,
  selectIsDetailsModalVisible,
  selectIsRemoveModalVisible,
} from "store/ExamStore/selectors";
import { Empty } from "components/Empty/Empty";
import { Button } from "components/Buttons/Button";
import { ButtonColorScheme } from "types/ui";
import { createNote, deleteNote, editNote } from "store/ExamStore/actions";
import { Note } from "types/Exam";
import {
  setDetailsModalVisibility,
  setRemoveModalVisibility,
} from "store/ExamStore/examSlice";
import { ExamNoteItem } from "../components/ExamNoteItem";
import { RemoveNoteModal } from "../components/RemoveNoteModal";
import { NoteDetailsModal } from "../components/NoteDetailsModal";
import { selectRequests } from "../../../store/LoadingStore/selectors";
import { Requests } from "../../../types/requests";

// TODO: refactor it
export const ExamNotesList = () => {
  const [chosenNoteId, setChosenNoteId] = React.useState("1");

  const dispatch = useAppDispatch();
  const currentExamRaw = useAppSelector(selectCurrentExam);
  const [currentExam, setCurrentExam] = React.useState(currentExamRaw);
  const loading = useAppSelector((state) =>
    selectRequests([Requests.getExam], state)
  );
  const isRemoveModalVisible = useAppSelector(selectIsRemoveModalVisible);
  const isDetailsModalVisible = useAppSelector(selectIsDetailsModalVisible);

  const chosenNote = useMemo(() => {
    return currentExam?.notes?.find((note) => note._id === chosenNoteId);
  }, [chosenNoteId]);

  const onCreateNote = useCallback(() => {
    const id = "1";
    setChosenNoteId(id);
    openDetailsModal();
  }, []);

  const onConfirmCreateNote = useCallback(
    (note: string) => {
      const examNote: Omit<Note, "createdAt"> = { _id: "", title: note };
      dispatch(createNote(examNote));
      setCurrentExam({
        ...currentExam,
        notes: [
          ...currentExam.notes,
          { _id: "1", createdAt: new Date().toISOString(), title: note },
        ],
      });
    },
    [chosenNoteId]
  );

  const onEditNote = useCallback((id: string) => {
    setChosenNoteId(id);
    openDetailsModal();
  }, []);

  const onConfirmEditNote = useCallback(
    (note: string) => {
      if (chosenNote?._id) {
        dispatch(editNote({ ...chosenNote, title: note }));
        setCurrentExam({
          ...currentExam,
          notes: currentExam.notes.map((noteList) =>
            noteList._id === chosenNote?._id
              ? { ...noteList, title: note }
              : noteList
          ),
        });
      }
    },
    [chosenNoteId]
  );

  const onConfirmDeleteNote = useCallback(() => {
    dispatch(deleteNote(chosenNoteId));
  }, [chosenNoteId]);

  const onDeleteNote = useCallback((id) => {
    setChosenNoteId(id);
    openRemoveModal();
  }, []);

  const openRemoveModal = useCallback(() => {
    dispatch(setRemoveModalVisibility(true));
  }, []);

  const closeRemoveModal = useCallback(() => {
    dispatch(setRemoveModalVisibility(false));
  }, []);

  const openDetailsModal = useCallback(() => {
    dispatch(setDetailsModalVisibility(true));
  }, []);

  const closeDetailsModal = useCallback(() => {
    dispatch(setDetailsModalVisibility(false));
  }, []);

  useEffect(() => {
    setCurrentExam(currentExamRaw);
  }, [currentExamRaw]);
  return (
    <article className="mt-10">
      {loading ? (
        <div className="w-full flex items-center justify-between mt-10 pl-5 pr-2">
          <div className="w-24 h-24 flex flex-col justify-center">
            <Skeleton />
          </div>
          <div className="w-24 h-24 flex flex-col justify-center">
            <Skeleton height={40} />
          </div>
        </div>
      ) : (
        <div className="w-full flex items-center justify-between mt-10 pl-5 pr-2">
          <h3 className="">Exam Notes</h3>
          <Button
            title="Add Note"
            onClick={onCreateNote}
            colorScheme={ButtonColorScheme.primary}
          />
        </div>
      )}

      <div className="flex flex-col space-y-2 mt-8 max-h-[285px] overflow-y-scroll">
        {loading ? (
          <>
            <Skeleton height={40} count={4} />
          </>
        ) : (
          <>
            {!!currentExam.notes?.length &&
              currentExam.notes.map((examNote, index) => {
                return (
                  <ExamNoteItem
                    id={examNote._id}
                    key={examNote._id}
                    text={examNote.title}
                    index={index}
                    onDelete={onDeleteNote}
                    onEdit={onEditNote}
                  />
                );
              })}
          </>
        )}

        {!currentExam.notes?.length && !loading && <Empty />}
      </div>
      <RemoveNoteModal
        showModal={isRemoveModalVisible}
        onConfirm={onConfirmDeleteNote}
        headerText={"Delete Note"}
        bodyText={
          "Are you sure you want to delete this Note? If you confirm,\n" +
          " this note will be deleted permanently."
        }
        onClose={closeRemoveModal}
      />
      <NoteDetailsModal
        noteId={chosenNoteId}
        showModal={isDetailsModalVisible}
        onConfirm={
          chosenNoteId === "1" ? onConfirmCreateNote : onConfirmEditNote
        }
        onClose={closeDetailsModal}
        note={chosenNote?.title}
      />
    </article>
  );
};
